import Color from 'color';
import { styled } from '@mui/styles';
import { Button, CircularProgress } from '@mui/material';
import { FONT_FAMILY } from 'styles/variables/typography';
import {
  COLOR_GRAY_40,
  COLOR_GRAY_90,
  COLOR_PURPLE,
  COLOR_PURPLE_HOVER,
  COLOR_WHITE,
  COLOR_PINK_BRAND,
  COLOR_FACEBOOK,
  COLOR_RED,
} from 'styles/variables/colors';

const variant = {
  default: {
    color: COLOR_GRAY_90,
    background: COLOR_WHITE,
    border: `1px solid ${COLOR_GRAY_40}`,
  },
  defaultOutline: {
    color: COLOR_WHITE,
    border: `2px solid rgba(255, 255, 255, 0.8)`,
  },
  primary: {
    background: COLOR_PURPLE,
    color: COLOR_WHITE,
    ['&:hover']: {
      background: COLOR_PURPLE_HOVER,
    },
  },
  secondary: {
    background: COLOR_PINK_BRAND,
    color: COLOR_WHITE,
    ['&:hover']: {
      background: Color(COLOR_PINK_BRAND).darken(0.1).hex(),
    },
  },
  facebook: {
    background: COLOR_FACEBOOK,
    color: COLOR_WHITE,
    ['&:hover']: {
      background: Color(COLOR_FACEBOOK).darken(0.1).hex(),
    },
  },
  link: {
    color: COLOR_PURPLE,
  },
  danger: {
    background: COLOR_RED,
    color: COLOR_WHITE,
    minWidth: 150,
    width: 'auto',
    ['&:hover']: {
      background: Color(COLOR_RED).darken(0.1).hex(),
    },
  },
};

export const Container = styled(
  ({ children, className, type, disabled, disableElevation, onClick }) => {
    return <Button {...{ children, className, type, disabled, disableElevation, onClick }} />;
  },
)((props) => {
  return {
    fontFamily: FONT_FAMILY,
    fontWeight: 'bold',
    width: props.isInline ? 'initial' : '100%',
    fontSize: 16,
    textTransform: 'none',
    display: props.isInline ? 'inline-block' : 'block',
    lineHeight: 0,
    borderRadius: 35,
    boxShadow: 'none',
    height: 40,
    paddingLeft: 30,
    paddingRight: 30,
    marginTop: props.marginTop,
    marginRight: props.marginRight,
    marginBottom: props.marginBottom ?? 10,
    minWidth: props.minWidth,
    ...variant[props.variant],
  };
});

export const Loader = styled(({ className, size, thickness }) => {
  return <CircularProgress {...{ className, size, thickness }} />;
})((props) => {
  return {
    [`& .MuiCircularProgress-svg circle`]: {
      stroke: props.fillColor,
    },
  };
});
